import { MainLayout } from '@/componentes/Layout/MainLayout'

export const AboutUs = () => {
  return <MainLayout title="About us"> </MainLayout>
}
